// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3018fc4c","511":"6fd482fc","819":"71c3bdfe"}[chunkId] + ".chunk.js";
};